import type { GraphMode } from './commonTypes';

export type MiniTutorialUserField =
	| 'hideMiniTutorialInspire'
	| 'hideMiniTutorialIdeate'
	| 'hideMiniTutorialMoodboard';

export const MINI_TUTORIAL_USER_FIELDS: Record<GraphMode, MiniTutorialUserField> = {
	inspire: 'hideMiniTutorialInspire',
	ideate: 'hideMiniTutorialIdeate',
	moodboard: 'hideMiniTutorialMoodboard',
};

/** camelCase keys for `document.body.dataset`. */
export const MINI_TUTORIAL_DATASET_KEYS: Record<GraphMode, MiniTutorialUserField> = {
	inspire: 'hideMiniTutorialInspire',
	ideate: 'hideMiniTutorialIdeate',
	moodboard: 'hideMiniTutorialMoodboard',
};

export const miniTutorialStorageKey = (mode: GraphMode): string => `hide-mini-tutorial:${mode}`;

export const applyHideMiniTutorial = (
	user: Partial<Record<MiniTutorialUserField, boolean>>,
	mode: GraphMode
): void => {
	user[MINI_TUTORIAL_USER_FIELDS[mode]] = true;
};
